// Entrées, plats, cocktails
export interface DetailedDish {
  id: string
  title: string
  ingredients: string
  position: number
  price?: string | undefined
  option?: string | undefined
  image?: string | undefined
  description?: string | undefined
  foodRestrictions?: string[] | undefined
  moreLink?: string | undefined
}

// Desserts, fûts, bouteilles, rhums, whiskeys
export interface BriefDish {
  id: string
  title: string
  price: string
  position: number
  image?: string | undefined
  description?: string | undefined
  foodRestrictions?: string[] | undefined
  moreLink?: string | undefined
}

export interface Gin {
  id: string
  title: string
  origin: string
  ingredients: string
  suggestion?: string | undefined
  price: string
  position: number
  image?: string | undefined
  description?: string | undefined
  moreLink?: string | undefined
  flavors?: string[] | undefined
}

export interface Tonic {
  id: string
  title: string
  ingredients: string
  price: string
  position: number
  image?: string | undefined
  description?: string | undefined
  moreLink?: string | undefined
}

export enum FirestoreCollection {
  bouteilles = "Bouteilles",
  cocktails = "Cocktails",
  desserts = "Desserts",
  entrees = "Entrées",
  futs = "Fûts",
  vinsRouges = "Vins rouge",
  vinsBlancs = "Vins blanc",
  gins = "Gins",
  plats = "Plats",
  tonics = "Tonics",
}

export enum FoodRestrictions {
  vege = "Végé",
  vegan = "Vegan",
  spicy = "Épicé",
  noGluten = "Sans gluten",
  noNuts = "Sans noix",
  noDairy = "Sans produits laitiers",
}

export enum GinFlavors {
  floral = "Floral",
  fruity = "Fruité",
  saline = "Salin",
  herbaceous = "Herbacé",
  citrus = "Agrumes",
  spicy = "Épicé",
  bio = "Bio",
  woody = "Boisé",
}
